import React from 'react'
import * as R from 'ramda'
import { utils } from '@ims/1edtech-frontend-common'

import { Screen, View, Spinner, SearchBox } from 'lib/components'
import BaseCommonCartridgeCharacterizationsBreadCrumbs from 'domains/characterizations/components/BaseCommonCartridgeCharacterizationsBreadCrumbs'
import useFullCommonCartridgeCharacterization from 'domains/commonCartridge/hooks/useFullCommonCartridgeCharacterization'
import GenericError from 'domains/application/components/GenericError'
import ICharacterization from 'domains/characterizations/models/ICharacterization'
import WidgetHeader from 'domains/dashboard/components/WidgetHeader'
import ICommonCartridgeCharacterizationReport from 'domains/commonCartridge/models/ICommonCartridgeCharacterizationReport'
import { getCharacterizationRoute } from 'domains/characterizations/navigation/routes'
import CommonCartridgeCharacterizationReportStandardsList from 'domains/commonCartridge/components/CommonCartridgeCharacterizationReport/CommonCartridgeCharacterizationReportStandardsList'
import trackCommonCartridgeAnalytics from 'domains/commonCartridge/utils/trackCommonCartridgeAnalytics'

export default function CommonCartridgeCharacterizationReportStandardsScreen(
  props: any,
) {
  const [
    characterizationData,
    reportData,
    pending,
  ] = useFullCommonCartridgeCharacterization(props)
  const [query, setQuery] = React.useState('')

  if (
    pending ||
    !utils.hasValue(characterizationData) ||
    !utils.hasValue(reportData)
  ) {
    if (
      !pending &&
      (!utils.hasValue(characterizationData) || !utils.hasValue(reportData))
    ) {
      return <GenericError />
    }
    return (
      <Screen>
        <BaseCommonCartridgeCharacterizationsBreadCrumbs
          crumbs={[{ name: 'Standards' }]}
        />

        <View variant="paper">
          <WidgetHeader title="Standards" />
          <Spinner centered={true} />
        </View>
      </Screen>
    )
  }

  const characterization = characterizationData as ICharacterization
  const characterizationName = R.pathOr('', ['name'], characterization)
  const report = reportData as ICommonCartridgeCharacterizationReport

  return (
    <Screen>
      <BaseCommonCartridgeCharacterizationsBreadCrumbs
        crumbs={[
          {
            name: utils.string.ellipsize(characterizationName, 30),
            route: getCharacterizationRoute(
              characterization.id,
              characterization.format,
            ),
          },
          { name: 'Standards' },
        ]}
      />

      <View variant="paper">
        <View flexible="row-space-between-wrap">
          <WidgetHeader title="Standards" />

          <SearchBox
            name={`cc-standards-search`}
            trackEvent={trackCommonCartridgeAnalytics}
            trackEventAction={'cc-standards-search'}
            onChange={setQuery}
            placeholder="Search..."
          />
        </View>

        <View mt={3} />
        <CommonCartridgeCharacterizationReportStandardsList
          report={report}
          characterization={characterization}
          query={query}
          searchTemplate={'guid=~@@ OR label=~@@'}
        />
      </View>
    </Screen>
  )
}
